import { SectionOne } from "../components/feature/productDetail";

export default function ProductDetailPage()
{
    return(
        <section className="">
            <SectionOne/>
        </section>
    );
}